export interface DashboardRouter {
  goBack(prevState: { pathname: string; search: string }): void;
  goToEventList(side?: 'employee' | 'company', query?: string): void;
  goToPolicyList(): void;
  goToVacationList(): void;
  goToList(): void;
  goToWidgetsList(): void;
  goToPersonalLinksSettings(widgetId: string): void;
  goToNewsWidgetSettings(widgetId: string): void;
  goToSurveysSettings(widgetId: string): void;
  goToSurvey(id: string): void;
  goToExternalWidget(id: string, query?: string): void;
  goToQuickActionsSettings(widgetId: string): void;
  goToUserQuickActionUrl(url: string): void;
  goToHome(): void;
  goToPersonalDetail(userId: string): void;
  goToDetailPost(postId: string, communityId: string): void;
  goToDetailNews(newsId: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DashboardRouter = Symbol('DashboardRouter');
